var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('p',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.text))]),(_vm.showprogress)?_c('progress',{staticStyle:{"padding":"5px"},attrs:{"id":"progress-bar"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }